import React  from 'react'
import DropDown from '../dropdown';
import { useTextResources } from '../../../language';

const CreditTypeDropDown = (props) => {
    const text = useTextResources()
    const data = [{
        text: text("Payments"),
        value: "Payments"
    },{
        text: text("Credit"),
        value: "SpecialCredit"
    }]
    return <DropDown data={data} textField="text" valueField="value" {...props} />
}

export default CreditTypeDropDown
